module.exports = __webpack_public_path__ + "img/battery_grey_line.32e36835.png";